export const SET_MEASURES = "MEASURE/SET_MEASURES";
export const SET_MEASURE = "MEASURE/SET_MEASURE";
export const SET_PAGINATION = "MEASURE/SET_PAGINATION";
